import gql from 'graphql-tag'
import {IDS} from "../../Constants/IDS";

export const SUBSCRIBE_ALL_CUSTOMERS = gql`
    subscription($orgId:uuid!){
        RouteShops(where: {Route: {organizationId: {_eq: $orgId}}}, order_by:{created_at:desc}){
            id
            Organization {
                id
                name
                shopType
                gstInNumber
                status
                mobile
                whatsappNumber
                zone
                lat
                long
                totalDueAmount
                fssaiCode
                fssaiCodeExpiryDate
                created_at
                updated_at
                Address{
                    id
                    address1
                    address2
                    area
                    city
                    state
                    pincode
                    country
                }
                Type{
                    id
                    type
                }
                Users(where:{userTypeId:{_eq:"${IDS.userTypes.Customer}"}}){
                    id
                    name
                    mobile
                    email
                    userTypeId
                    birthDate
                    anniversary
                }
            }
        }
    }`

export const SUBSCRIBE_CUSTOMER_BY_ID = gql`
    subscription ($id:uuid!,$userType:uuid!){
        Organizations(where:{ id:{ _eq: $id}}){
            id
            name
            status
            mobile
            whatsappNumber
            gstInNumber
            zone
            lat
            long
            shopType
            fssaiCode
            fssaiCodeExpiryDate
            totalDueAmount
            orderSystem
            created_at
            updated_at
            Type{
                id
                type
            }
            CreatedBy{
                id
                name
            }
            UpdatedBy{
                id
                name
            }
            Users(where:{userTypeId:{_eq:$userType}}){
                id
                name
                mobile
                email
                birthDate
                anniversary
            }
            Address{
                id
                address1
                address2
                area
                city
                state
                country
                pincode
            }
            Routes_aggregate {
                aggregate {
                    count
                }
            }
        }
    }`

export const SUBSCRIBE_ORGANIZATION_TYPES = gql`
    subscription {
        OrganizationTypes(where:{type:{_neq:"Distributor"}}){
            id
            type
        }
    }`
